import * as Types from './Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { RootState } from 'src/reducers/RootReducer';

export interface DeleteOfflineInvestorAttempt extends Action {
  type: Types.DELETE_OFFLINE_INVESTOR_ATTEMPT;
}

export interface DeleteOfflineInvestorSuccess extends Action {
  type: Types.DELETE_OFFLINE_INVESTOR_SUCCESS;
}

export interface DeleteOfflineInvestorFailure extends Action {
  type: Types.DELETE_OFFLINE_INVESTOR_FAILURE;
  payload: {};
}

export type DeleteOfflineInvestorAction =
  DeleteOfflineInvestorAttempt
  | DeleteOfflineInvestorSuccess
  | DeleteOfflineInvestorFailure;

export interface DeleteOfflineInvestorThunk extends
  ThunkAction<Promise<DeleteOfflineInvestorAction>, RootState, string> {
}

export const deleteOfflineInvestorAttempt: ActionCreator<DeleteOfflineInvestorAttempt> = () => (
  {
    type: Types.DELETE_OFFLINE_INVESTOR_ATTEMPT
  }
);

export const deleteOfflineInvestorSuccess: ActionCreator<DeleteOfflineInvestorSuccess> = () => (
  {
    type: Types.DELETE_OFFLINE_INVESTOR_SUCCESS
  }
);

export const deleteOfflineInvestorFailure: ActionCreator<DeleteOfflineInvestorFailure> = (error: {}) => (
  {
    type: Types.DELETE_OFFLINE_INVESTOR_FAILURE,
    payload: error
  }
);

export const deleteOfflineInvestor: ActionCreator<DeleteOfflineInvestorThunk> =
  (projectId: string, offlineInvestorId: string): DeleteOfflineInvestorThunk => {
    return (dispatch: Dispatch<RootState>): Promise<DeleteOfflineInvestorAction> => {
      dispatch(deleteOfflineInvestorAttempt());

      return ApiClient.offlineInvestor.delete(projectId, offlineInvestorId)
        .then((): DeleteOfflineInvestorSuccess => {
          return dispatch(deleteOfflineInvestorSuccess());
        }).catch((): DeleteOfflineInvestorFailure => {
          return dispatch(deleteOfflineInvestorFailure());
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/offline-investor/delete/DeleteOfflineInvestor.actions.tsx